import React from 'react';

export const Footer = (props) => {
    return (
        <div className="bg-gradient-primary p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row justify-between items-center">
                    <div className="flex flex-col items-center lg:items-start">
                        <h1 className="text-2xl lg:text-3xl font-bold text-white mb-2">
                            <img src="img/logo.png" alt="logo" className="w-auto h-auto max-w-24" />
                        </h1>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-2">
                        <div className="text-2xl lg:text-3xl font-extralight text-white gap-8">
                            <p className="text-sm py-0.5 font-nunito">About Us</p>
                            <p className="text-sm py-0.5 font-nunito">Contact</p>
                            <p className="text-sm py-0.5 font-nunito">Products</p>
                            <p className="text-sm py-0.5 font-nunito">Resources</p>
                        </div>
                        <div className="text-2xl lg:text-3xl font-extralight text-white">
                            <p className="text-sm py-0.5 font-nunito">Terms and Conditions</p>
                            <p className="text-sm py-0.5 font-nunito">Privacy Policy</p>
                            <p className="text-sm py-0.5 font-nunito">Cookie Policy</p>
                            <p className="text-sm py-2 font-nunito">© 2023 AmpTrans</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}